import { Component } from '@angular/core';

@Component({
  selector: 'tln-hr-logo',
  styleUrl: './hr-logo.component.less',
  templateUrl: './hr-logo.component.html',
  standalone: true,
})
export class HrLogoComponent {}
